export default {
  injuryImpact: {
    title: "Infortuni",
    labels: {
      withoutPlayer: "Senza {{player}}",
    },
    empty: {
      title: "Nessun infortunio disponibile",
    },
  },
};
